/** * 自定义订阅分类 * 点击订阅按钮，弹出勾选订阅列表的弹框 */
import Vue from "vue"
import subscribeDialog from "./subscribe.vue"
import { getCookie } from "utils"
export default {
  components: { subscribeDialog },
  // watch: {
  //   tabLists: {
  //     deep: true,
  //     handler(n, o) {
  //       if (n.length !== o.length && this.options.pluginName.includes("subscribe")) {
  //         this.$nextTick(() => {
  //           this.subscribe()
  //         })
  //       }
  //     }
  //   }
  // },
  methods: {
    subscribe() {
      // 登录之后才展示订阅按钮
      let UID = getCookie("UID")
      if (!UID) {
        return
      }
      let btn = document.createElement("div")
      btn.innerHTML =
        "<span style='display: inline-block;vertical-align: middle;margin-right: 2px;line-height:21px;' class='icon-portal-plus'></span><span style='display: inline-block;vertical-align: middle'>订阅</span>"
      btn.setAttribute("class", "tab subscribe-btn")
      btn.setAttribute(
        "style",
        "position: absolute;top:50%;right:0px;transform: translateY(-50%);padding:0 8px;color:#fff;background:#C4C4C4;border-radius:15px;display:inline-block;vertical-align:middle;margin-left:8px;line-height:21px;text-align:center;cursor: pointer;font-size:14px"
      )
      let subscribeBtn = this.$el.getElementsByClassName("subscribe-btn")
      if (subscribeBtn.length) {
        this.$el.removeChild(subscribeBtn[0])
      }
      this.$el.appendChild(btn)
      btn.onclick = () => {
        sessionStorage.setItem("checkedList", JSON.stringify(this.tabLists))
        let wrap = document.createElement("div")
        wrap.id = "dialog"
        document.getElementById("app").appendChild(wrap)
        const Ss = Vue.extend(subscribeDialog)
        new Ss().$mount("#dialog")
      }
    }
  }
}
